import { cn } from "@/lib/utils";

/** The count beside a sidebar tab (a dot on the icon when the sidebar is folded). */
export function SidebarBadge({ count, label, dot }: { count?: number; label?: string; dot?: boolean }) {
  if (!count) return null;
  const text = count > 99 ? "99+" : String(count);
  if (dot) {
    return <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-red-500" aria-hidden />;
  }
  return (
    <span
      className={cn("ml-auto min-w-[1.25rem] rounded-full bg-red-500 px-1.5 py-0.5 text-center text-[11px] font-semibold leading-none text-white")}
      aria-label={label ? `${count} in ${label}` : `${count}`}
      data-testid="sidebar-badge"
    >
      {text}
    </span>
  );
}
